import React, { useState, useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { RefreshSpotifyAccessToken } from '../../services/foundation';

export const TokenContext = React.createContext();

/** 
 * Ok, I know this is a really dodgy way to do things, but because Spotify deprecated the old way of authentication and I don't want to do 
 * a massive rework, this will have to do for now
 */

const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [cookies, setCookie] = useCookies(['spotify_refresh_token']);
  const refreshingRef = useRef(false);

  // On mount: check if a refresh token exists in cookies and generate new token
  useEffect(() => {
    const initializeFromCookie = async () => {
      const refreshToken = cookies.spotify_refresh_token;
      if (refreshToken && !token) {
        const newToken = await RefreshSpotifyAccessToken({ refresh_token: refreshToken });
        setToken(newToken);

        // Update cookie in case refresh token changed
        if (newToken.refresh_token) {
          setCookie('spotify_refresh_token', newToken.refresh_token, {
            path: '/',
            maxAge: 60 * 60 * 24, // 1 day
            sameSite: 'lax'
          });
        }
      }
    };

    initializeFromCookie();
  }, []); // run only on mount

  // Background auto-refresh every 30 seconds
  useEffect(() => {
    const interval = setInterval(async () => {
      if (!token) return;

      const now = Date.now();
      // Refresh 10s before expiry for safety
      if (!refreshingRef.current && now > (token.generated_at + (3600 * 1000) - 10000)) {
        refreshingRef.current = true;

        const newToken = await RefreshSpotifyAccessToken(token);
        setToken(newToken);

        // Store the new refresh token in a cookie (1 day expiry)
        if (newToken.refresh_token) {
          setCookie('spotify_refresh_token', newToken.refresh_token, {
            path: '/',
            maxAge: 60 * 60 * 24, // 1 day
            sameSite: 'lax'
          });
        }

        refreshingRef.current = false;
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [token, setCookie]);

  // Synchronous getter for old code
  const getToken = () => token;

  return (
    <TokenContext.Provider value={[getToken, setToken]}>
      {children}
    </TokenContext.Provider>
  );
};

export default TokenProvider;